/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeBreakpointContext,
  BaSeButton,
  BaSeParagraph,
  BaSeShapeButton,
  BaSeSmall1,
  BaSeSmall2,
} from '@base/react';
import React from 'react';
import {
  AlignTitle,
  Container,
  ContentDetail,
  HeaderTitle,
  ProgressBarContainer,
  ProgressBarContent,
  Title,
} from '../../components/progress-bar/progress-bar-style';

function ProgressBar({
  value,
  max,
  title,
  withDetailDescription = false,
  titleDetailDescription,
  detailDescription,
  isBold = false,
  colorTitle = '#636363',
  controleDetailInBar = true,
  colofFillProgress = '#d0af52',
}) {
  const percentage = (value / max) * 100;
  const [open, setOpen] = React.useState(true);

  const { onMobileSmall, onMobile, onMobileLarge } = React.useContext(
    BaSeBreakpointContext,
  );
  const isMobile = onMobile || onMobileSmall || onMobileLarge;

  return (
    <Container>
      <HeaderTitle>
        <Title>
          <AlignTitle>
            {title && (
              <BaSeSmall1 isBold={isBold} color={colorTitle}>
                {title}
              </BaSeSmall1>
            )}
            {!isMobile && withDetailDescription && (
              <BaSeShapeButton
                buttonType="button"
                color="default"
                nameIcon="character/lato/question"
                popover={{
                  direction: 'bottom',
                  width: 100,
                  title: `${titleDetailDescription}`,
                  renderContent: () => (
                    <ContentDetail>
                      <BaSeSmall2 color="#5C6C7D">
                        {detailDescription}
                      </BaSeSmall2>
                    </ContentDetail>
                  ),
                }}
                shape="circle"
                size="extra-small"
                sizeIcon="small"
                type="secondary"
              />
            )}
          </AlignTitle>
        </Title>
        <BaSeParagraph color={colorTitle} isBold={isBold}>
          {value}
        </BaSeParagraph>
      </HeaderTitle>

      <ProgressBarContainer>
        <ProgressBarContent
          colofFillProgress={colofFillProgress}
          style={{ width: `${percentage}%` }}
        />
      </ProgressBarContainer>

      {controleDetailInBar && open && isMobile && (
        <BaSeSmall2 color="#636363">{detailDescription}</BaSeSmall2>
      )}

      {controleDetailInBar && isMobile && (
        <div style={{ marginLeft: 'auto' }}>
          <BaSeButton
            buttonType="button"
            color="default"
            loadingText="Carregando…"
            onClick={() => setOpen((prev) => !prev)}
            rightIcon={
              open ? 'system/arrow-down-s-line' : 'system/arrow-up-s-line'
            }
            size="small"
            type="tertiary"
            value={open ? 'Fechar' : 'Saiba mais'}
          />
        </div>
      )}
    </Container>
  );
}

export default ProgressBar;
